import type { SVGProps } from "react";
export interface BugIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BugIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BugIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 22v-.113a4.125 4.125 0 0 1 3.197-4.02l.926-.214.252 1.098.253 1.095-.924.214a1.874 1.874 0 0 0-1.454 1.827V22a1.125 1.125 0 0 1-2.25 0m18 0v-.113c0-.819-.53-1.536-1.297-1.784l-.157-.043-.924-.214a1.125 1.125 0 0 1 .506-2.193l.925.214.344.095a4.13 4.13 0 0 1 2.854 3.925V22a1.125 1.125 0 0 1-2.25 0Zm-9-.5v-8.374H5.46a4.126 4.126 0 0 1-4.046-3.317l-.018-.088-.016-.114a1.125 1.125 0 0 1 2.195-.44l.028.112.017.09a1.88 1.88 0 0 0 1.84 1.507h13.081c.893 0 1.663-.632 1.838-1.508l.018-.09a1.125 1.125 0 0 1 2.206.443l-.018.088a4.125 4.125 0 0 1-4.044 3.317h-5.415V21.5a1.125 1.125 0 0 1-2.25 0Zm-4.877-3.847a1.126 1.126 0 0 1 .505 2.193zM5 14.375a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 1 1 0-2.25zm17 0a1.125 1.125 0 0 1 0 2.25h-3a1.125 1.125 0 0 1 0-2.25zm-7.4-13.05a1.125 1.125 0 0 1 1.8 1.35L14.708 4.93a1.125 1.125 0 0 1-1.8-1.35L14.6 1.326ZM7.825 1.1a1.125 1.125 0 0 1 1.502.136l.074.088 1.692 2.254.065.095a1.125 1.125 0 0 1-1.79 1.345l-.075-.09L7.6 2.676l-.064-.095a1.125 1.125 0 0 1 .288-1.48Z"
      />
      <path
        fill={color}
        d="M17.375 10.5a5.376 5.376 0 0 0-10.75 0v5a5.375 5.375 0 0 0 10.75 0zm2.25 5a7.626 7.626 0 0 1-15.25 0v-5a7.625 7.625 0 0 1 15.25 0z"
      />
    </svg>
  );
}
